import { useEffect, useState } from 'react';

import Portal from 'ui/portal';

import TailSpin from './tailSpin';

import s from './loaderSpinner.module.css';

function LoaderSpinner() {
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    setOpened(true);
  }, []);

  const backdropStyles = opened ? s.backdrop : s.backdrop_hidden;
  const loaderStyles = opened ? s.loader : s.loader_hidden;

  return (
    <Portal>
      <div className={backdropStyles}>
        <div className={loaderStyles}>
          <TailSpin width={100} height={100} color="#828282" />
        </div>
      </div>
    </Portal>
  );
}

export default LoaderSpinner;
